import { createRoot } from "react-dom/client";
import { Main } from "./Main";

// Set favicon based on domain
const setFavicon = () => {
  const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;

  if (link && window.location.hostname === "staging.airplx.com") {
    // Use the staging favicon directly
    link.href = "./favicon-staging.png";
  }
};

// Set favicon on load
setFavicon();

const app = document.getElementById("app");

if (app) {
  const root = createRoot(app);
  root.render(<Main />);
}
